export default {
  REGISTER_VARIANT: 'REGISTER_VARIANT`',
  ENROL: 'ENROL',
  ENROL_COMPLETE: 'ENROL_COMPLETE',
};
